var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#FB5012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 31.5L22.6727 26.7714C22.8024 26.5419 22.9163 26.3404 23.0182 26.1622M23.0182 26.1622C23.3341 25.6097 23.535 25.2806 23.7358 25.0336C25.3978 22.9885 28.3618 22.5845 30.5106 24.1101C30.8516 24.3522 31.2309 24.7309 31.985 25.485M23.0182 26.1622L22.5 26C21.3045 25.7609 20.7067 25.6413 20.1581 25.653C18.6898 25.6842 17.3096 26.3593 16.3835 27.4991C16.0375 27.925 15.7649 28.4702 15.2196 29.5607L15.1098 29.7804L14.9887 29.9849M31.985 25.485C32 24.7605 32 23.939 32 23C32 19.2503 32 17.3754 31.0451 16.0611C30.7367 15.6366 30.3634 15.2633 29.9389 14.9549C28.6246 14 26.7497 14 23 14C19.2503 14 17.3754 14 16.0611 14.9549C15.6366 15.2633 15.2633 15.6366 14.9549 16.0611C14 17.3754 14 19.2503 14 23C14 26.7497 14 28.6246 14.9549 29.9389C14.9661 29.9543 14.9774 29.9697 14.9887 29.9849M31.985 25.485C31.9401 27.6536 31.7609 28.9537 31.0451 29.9389C30.7367 30.3634 30.3634 30.7367 29.9389 31.0451C28.6246 32 26.7497 32 23 32C19.2503 32 17.3754 32 16.0611 31.0451C15.652 30.7479 15.2905 30.3904 14.9887 29.9849M20 20C20 21.1046 20.8954 22 22 22C23.1046 22 24 21.1046 24 20C24 18.8954 23.1046 18 22 18C20.8954 18 20 18.8954 20 20Z",
    stroke: "#FFFFFC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanface);
export default __webpack_public_path__ + "static/media/scanface.44b380a191262da61dec25efc1f06268.svg";
export { ForwardRef as ReactComponent };